import React from "react";

// Same qualitative banding as the rest of the AI Insights panel (no
// separate color language - stays inside the app's navy/tan palette
// instead of a red/yellow/green traffic light).
const difficultyBand = (value) => {
  const n = parseInt(value, 10);
  if (!Number.isFinite(n)) return null;
  if (n <= 3) return "Low difficulty";
  if (n <= 6) return "Moderate difficulty";
  if (n <= 8) return "High difficulty";
  return "Very high difficulty";
};

function AiCaseAnalysis({
  aiDifficulty,
  aiDataGaps = [],
  aiQuestions = [],
}) {
  const band = difficultyBand(aiDifficulty);
  return (
    <div className="font-plexsans">
      <h2 className="text-2xl font-spectral text-navy mb-4">
        Case Analysis
      </h2>

      {/* Difficulty */}
      <div className="inline-block min-w-[220px] border border-[rgba(20,33,61,.12)] rounded-[10px] p-4 mb-4">
        <div className="text-[13px] text-[rgba(20,33,61,.5)]">
          Case Difficulty
        </div>
        <div className="text-2xl font-semibold text-navy mt-1">
          {band || "—"}
        </div>
        {band && (
          <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-0.5">
            Score: {aiDifficulty}/10
          </div>
        )}
      </div>

      {/* Data Gaps */}
      {aiDataGaps?.length > 0 && (
        <div className="mb-4">
          <div className="text-[13px] font-medium text-tan mb-2">
            Missing information
          </div>

          <ul className="space-y-1.5">
            {aiDataGaps.map((item, index) => (
              <li
                key={index}
                className="text-[14px] text-tan flex gap-2"
              >
                <span className="text-tan">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Questions */}
      {aiQuestions?.length > 0 && (
        <div className="">
          <div className="text-[13px] font-medium text-tan mb-2">
            Questions to ask your attorney
          </div>

          <ol className="space-y-2">
            {aiQuestions.map((question, index) => (
              <li
                key={index}
                className="text-[14px] text-blue-700 flex gap-2"
              >
                <span className="font-medium text-blue-700 min-w-[16px]">
                  {index + 1}.
                </span>

                <span>{question}</span>
              </li>
            ))}
          </ol>
        </div>
      )}

    </div>
  );
}

export default AiCaseAnalysis;
